export function BrandLogo({ className = '' }: { className?: string }) {
  return <img className={`brand-logo ${className}`} src="/dhuwit-logo.png" alt="" aria-hidden="true" />
}
